import controller from './add-vehicle.controller'
import template   from './add-vehicle.html'
import './add-vehicle.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/add-vehicle/add-vehicle.component.js